export const makeActionCreator = (type, ...argNames) => (...args) => {
  const action = { type };
  argNames.forEach((arg, index) => {
    action[argNames[index]] = args[index];
  });
  return action;
};

/**
 * Toggles the presence of an item in an array given an item and the array to toggle its
 * presence in.
 *
 * @param {Array} items - Array of items
 * @param {Any} item - Item to toggle in the above array
 * @return {Array} - A copy of the updated array
 */
export const toggleItemInArray = (filters, filter) => {
  const updatedFilters = Array.from(filters);
  const index = filters.indexOf(filter);

  if (index > -1) {
    updatedFilters.splice(index, 1);
  } else {
    updatedFilters.push(filter);
  }

  return updatedFilters;
};

/**
 * Identifies if two arrays have common items. There's several ways to do this. For this helper
 * We'll sacrifice space complexity O(a) for better runtime complexity (O(a + b)), assuming that
 * the arrays have relatively few items.
 *
 * @param {Array} array1 - First array to compare.
 * @param {Array} array2 - Second array to compare.
 * @return {Boolean} - Whether or not the two arrays have a common item.
 */
export const haveCommonItem = (array1, array2) => {
  const seenItems = {};

  // eslint-disable-next-line no-return-assign
  array1.forEach(i => (seenItems[i] = i));
  return array2.some(i => seenItems[i]);
};
